const _ = require('./enum');

const status = {
  [_.CREATED]: { id: _.CREATED, label: 'Created', type: 'created', result: 'created' },
  [_.RISK_ASSESSMENT_APPROVED]: {
    id: _.RISK_ASSESSMENT_APPROVED,
    label: 'Risk assessment approved',
    type: 'risk_assessment',
    result: 'approved',
  },
  [_.RISK_ASSESSMENT_DECLINED]: {
    id: _.RISK_ASSESSMENT_DECLINED,
    label: 'Risk assessment declined',
    type: 'risk_assessment',
    result: 'declined',
  },
  [_.RISK_ASSESSMENT_REQUESTED]: {
    id: _.RISK_ASSESSMENT_REQUESTED,
    label: 'Risk assessment requested',
    type: 'risk_assessment',
    result: 'requested',
  },
  [_.RISK_ASSESSMENT_REQUEST_FAILED]: {
    id: _.RISK_ASSESSMENT_REQUEST_FAILED,
    label: 'Risk assessment request failed',
    type: 'risk_assessment',
    result: 'request_failed',
  },
  [_.RISK_ASSESSMENT_MANUAL_REVIEW]: {
    id: _.RISK_ASSESSMENT_MANUAL_REVIEW,
    label: 'Risk assessment manual review',
    type: 'risk_assessment',
    result: 'manual_review',
  },
  [_.AUTHENTICATION_ATTEMPTED]: {
    id: _.AUTHENTICATION_ATTEMPTED,
    label: 'Authentication attempted',
    type: 'authentication',
    result: 'attempted',
  },
  [_.AUTHENTICATION_DECLINED]: {
    id: _.AUTHENTICATION_DECLINED,
    label: 'Authentication declined',
    type: 'authentication',
    result: 'declined',
  },
  [_.AUTHENTICATION_REQUEST_FAILED]: {
    id: _.AUTHENTICATION_REQUEST_FAILED,
    label: 'Authentication request failed',
    type: 'authentication',
    result: 'request_failed',
  },
  [_.AUTHENTICATION_REQUEST_EXPIRED]: {
    id: _.AUTHENTICATION_REQUEST_EXPIRED,
    label: 'Authentication request expired',
    type: 'authentication',
    result: 'request_expired',
  },
  [_.AUTHENTICATION_REQUESTED]: {
    id: _.AUTHENTICATION_REQUESTED,
    label: 'Authentication requested',
    type: 'authentication',
    result: 'requested',
  },
  [_.AUTHENTICATION_SUCCESSFUL]: {
    id: _.AUTHENTICATION_SUCCESSFUL,
    label: 'Authentication successful',
    type: 'authentication',
    result: 'successful',
  },
  [_.AUTHORIZATION_CANCEL_DECLINED]: {
    id: _.AUTHORIZATION_CANCEL_DECLINED,
    label: 'Authorization cancel declined',
    type: 'authorization_cancel',
    result: 'declined',
  },
  [_.AUTHORIZATION_CANCEL_REQUEST_FAILED]: {
    id: _.AUTHORIZATION_CANCEL_REQUEST_FAILED,
    label: 'Authorization cancel request failed',
    type: 'authorization_cancel',
    result: 'request_failed',
  },
  [_.AUTHORIZATION_CANCEL_REQUESTED]: {
    id: _.AUTHORIZATION_CANCEL_REQUESTED,
    label: 'Authorization cancel requested',
    type: 'authorization_cancel',
    result: 'requested',
  },
  [_.AUTHORIZATION_CANCEL_SUCCESSFUL]: {
    id: _.AUTHORIZATION_CANCEL_SUCCESSFUL,
    label: 'Authorization cancel successful',
    type: 'authorization_cancel',
    result: 'successful',
  },
  [_.AUTHORIZATION_DECLINED]: {
    id: _.AUTHORIZATION_DECLINED,
    label: 'Authorization declined',
    type: 'authorization',
    result: 'declined',
  },
  [_.AUTHORIZATION_EXPIRED]: {
    id: _.AUTHORIZATION_EXPIRED,
    label: 'Authorization expired',
    type: 'authorization',
    result: 'expired',
  },
  [_.AUTHORIZATION_RENEWED]: {
    id: _.AUTHORIZATION_RENEWED,
    label: 'Authorization renewed',
    type: 'authorization',
    result: 'renewed',
  },
  [_.AUTHORIZATION_FAILED]: {
    id: _.AUTHORIZATION_FAILED,
    label: 'Authorization failed',
    type: 'authorization',
    result: 'failed',
  },
  [_.AUTHORIZATION_REQUEST_FAILED]: {
    id: _.AUTHORIZATION_REQUEST_FAILED,
    label: 'Authorization request failed',
    type: 'authorization',
    result: 'request_failed',
  },
  [_.AUTHORIZATION_REQUEST_EXPIRED]: {
    id: _.AUTHORIZATION_REQUEST_EXPIRED,
    label: 'Authorization request expired',
    type: 'authorization',
    result: 'request_expired',
  },
  [_.AUTHORIZATION_REQUESTED]: {
    id: _.AUTHORIZATION_REQUESTED,
    label: 'Authorization requested',
    type: 'authorization',
    result: 'requested',
  },
  [_.AUTHORIZATION_SUCCESSFUL]: {
    id: _.AUTHORIZATION_SUCCESSFUL,
    label: 'Authorization successful',
    type: 'authorization',
    result: 'successful',
  },
  [_.CAPTURE_DECLINED]: { id: _.CAPTURE_DECLINED, label: 'Capture declined', type: 'capture', result: 'declined' },
  [_.CAPTURE_REQUEST_FAILED]: {
    id: _.CAPTURE_REQUEST_FAILED,
    label: 'Capture request failed',
    type: 'capture',
    result: 'request_failed',
  },
  [_.CAPTURE_REQUESTED]: { id: _.CAPTURE_REQUESTED, label: 'Capture requested', type: 'capture', result: 'requested' },
  [_.CAPTURE_SUCCESSFUL]: {
    id: _.CAPTURE_SUCCESSFUL,
    label: 'Capture successful',
    type: 'capture',
    result: 'successful',
  },
  [_.CREDIT_DECLINED]: { id: _.CREDIT_DECLINED, label: 'Credit declined', type: 'credit', result: 'declined' },
  [_.CREDIT_REQUEST_FAILED]: {
    id: _.CREDIT_REQUEST_FAILED,
    label: 'Credit request failed',
    type: 'credit',
    result: 'request_failed',
  },
  [_.CREDIT_REQUESTED]: { id: _.CREDIT_REQUESTED, label: 'Credit requested', type: 'credit', result: 'requested' },
  [_.CREDIT_SUCCESSFUL]: {
    id: _.CREDIT_SUCCESSFUL,
    label: 'Credit successful',
    type: 'credit',
    result: 'successful',
  },
  [_.REFUND_DECLINED]: { id: _.REFUND_DECLINED, label: 'Refund declined', type: 'refund', result: 'declined' },
  [_.REFUND_REQUEST_FAILED]: {
    id: _.REFUND_REQUEST_FAILED,
    label: 'Refund request failed',
    type: 'refund',
    result: 'request_failed',
  },
  [_.REFUND_REQUESTED]: { id: _.REFUND_REQUESTED, label: 'Refund requested', type: 'refund', result: 'requested' },
  [_.REFUND_SUCCESSFUL]: { id: _.REFUND_SUCCESSFUL, label: 'Refund successful', type: 'refund', result: 'successful' },
  [_.PAID]: { id: _.PAID, label: 'Paid', type: 'paid', result: 'paid' },
  [_.CHARGED_BACK]: { id: _.CHARGED_BACK, label: 'Charged back', type: 'charged_back', result: 'charged_back' },
  [_.BLOCKED_BY_ROUTER]: { id: _.BLOCKED_BY_ROUTER, label: 'Blocked by router', type: 'blocked', result: 'failed' },
  [_.ROUTE_NOT_FOUND]: { id: _.ROUTE_NOT_FOUND, label: 'Route not found', type: 'routing', result: 'failed' },
};

module.exports = status;
